
const determineAPIOrigin = () => {
    // console.log("apiOrigin", window.location.hostname);
    switch (window.location.hostname) {
        case 'qa-customer.subtrux-test.net':
            return 'https://qa.subtrux-test.net';
        case 'customer.subtrux.com':
            return 'https://app.subtrux.com';
        case '10.0.2.2': /* Android Emulator */
            return 'http://10.0.2.2:9330';
        case 'localhost':
        case '127.0.0.1':
            return 'http://localhost:9330';
        default:
            return ''
    }
};

const origin = (): string => {
    return determineAPIOrigin();
}

export const API_ORIGIN: string = origin();

const API = {
    origin,
    ORIGIN: API_ORIGIN,
}

export default API;
